import { ChatState } from './types';
import { Message } from 'components/chat-drawer/chat.types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const generateUUID = (): string => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const initialState: ChatState = {
  sessionId: '',
  messages: [],
};

export const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    initializeChat(state) {
      if (!state.sessionId) {
        state.sessionId = generateUUID();
        state.messages = [
          {
            id: 'greeting',
            sender: 'bot',
            text: 'Merhaba! Ben Idecon AI Asistanıyım. Projeler, eforlar veya diğer konular hakkında nasıl yardımcı olabilirim?',
            timestamp: new Date(),
          },
        ];
      }
    },
    addMessage(state, action: PayloadAction<Message>) {
      state.messages.push(action.payload);
    },
    setSessionId(state, action: PayloadAction<string>) {
      state.sessionId = action.payload;
    },
    resetChatState(state) {
      state.sessionId = generateUUID();
      state.messages = [
        {
          id: 'greeting',
          sender: 'bot',
          text: 'Yeni bir sohbet başlattık! Size nasıl yardımcı olabilirim?',
          timestamp: new Date(),
        },
      ];
    },
  },
});

export const { initializeChat, addMessage, setSessionId, resetChatState } = chatSlice.actions;

export default chatSlice.reducer;
